// extracted by mini-css-extract-plugin
export var bxTextTruncateEnd = "LeftNav-module--bx--text-truncate--end--3PTQ2";
export var bxTextTruncateFront = "LeftNav-module--bx--text-truncate--front--Rk1IB";
export var currentItem = "LeftNav-module--current-item--2Pndd";
export var divider = "LeftNav-module--divider--PDTqp";
export var dividerSpace = "LeftNav-module--divider-space--2janF";
export var outboundLink = "LeftNav-module--outboundLink--1utkp";
export var sideNavDark = "LeftNav-module--side-nav--dark--1iW-O";
export var sideNavWhite = "LeftNav-module--side-nav--white--3u_TF";